<div class="main-container-full-page" *ngIf="displayFullPage">
  <div class="breadcrumb-and-edit-scheduler">
    <mwo-breadcrumb (click)="back()" title="{{ 'library.title' | translate }}"></mwo-breadcrumb>
    <mwo-main-button (onClick)="openEditInterface()" *ngIf="isSchedulerEditable()"
                     text="{{'planning.modify' | translate}}"></mwo-main-button>
  </div>
  <div class="scheduler-container-full-page">
    <div class="scheduler-container-col">
      <mwo-setlist-clock [slots$]="slots$" [showEqualizer$]="isPlayingFromSchedule$"
        [currentSlot$]="(currentSlot$ | async) ? currentSlot$ : currentSlotDay$" [isAnimated$]="isCurrentDaySelected$"
        [isCurrentDay$]="isCurrentDaySelected$" [day]="day" [context$]="context$"
        *ngIf="day !== '24'"></mwo-setlist-clock>
      <mwo-day-selector [activeDay]="activeDay$ | async" [justifyContentPosition]="'space-between'"
                        class="day-selection-full-page"
        (daySelected)="onActiveDayChanged($event)"></mwo-day-selector>
    </div>

    <div class="playlist-container-col">
      <mwo-setlist-planning [setlist]="slots$ | async"
        [isPlayingFromSchedule]="(isPlayingFromSchedule$ | async) && (isCurrentDaySelected$ | async)"
        [activeDay]="activeDay$ | async" (scheduleModeChanged)="onActiveDayChanged($event)"
        *ngIf="day !== '24'"></mwo-setlist-planning>
    </div>
  </div>

</div>

<div class="scheduler-container-flex-mode" *ngIf="!displayFullPage">
  <!-- TODO :: Translate ? -->
  <h3 class="scheduler-title" previousPage>Daily Mix</h3>

  <div class="scheduler-main-content">
    <div class="setlist-clock">
      <mwo-setlist-clock [slots$]="slots$" [showEqualizer$]="isPlayingFromSchedule$"
        [currentSlot$]="(currentSlot$ | async) ? currentSlot$ : currentSlotDay$" [isAnimated$]="isCurrentDaySelected$"
        [isCurrentDay$]="isCurrentDaySelected$" [day]="day" [context$]="context$"></mwo-setlist-clock>
      <mwo-day-selector class="day-selection" [playlistMode]="!displayFullPage" [justifyContentPosition]="'center'" [activeDay]="activeDay$ | async"
        (daySelected)="onActiveDayChanged($event)"></mwo-day-selector>
    </div>
    <div class="setlist-planning">
      <mwo-setlist-planning [playlistMode]="true" [setlist]="slots$ | async"
        [isPlayingFromSchedule]="(isPlayingFromSchedule$ | async) && (isCurrentDaySelected$ | async)"
        [activeDay]="activeDay$ | async" (scheduleModeChanged)="onActiveDayChanged($event)"></mwo-setlist-planning>
    </div>
  </div>

</div>
